import {DistanceProps, translatedDistanceProps} from 'modules/cities/types';
import useCreateCompanyDistance from 'modules/companies/hooks/use-create-distance';
import useEditCompanyDistance from 'modules/companies/hooks/use-edit-distance';
import {useLocation, useParams} from 'react-router-dom';
import Creation from 'shared/layout/creation';
import useFormInputs from 'shared/migration-components/form/util';

const CreateCompanyDistance: React.FC = () => {
  const {id} = useParams();
  const {state = {} as any} = useLocation();
  const {getSelect, getNumberInput, getPriceInput} =
    useFormInputs<DistanceProps>();

  return (
    <Creation
      defaultValues={{companyId: id, ...state}}
      translationKey={translatedDistanceProps}
      onSubmit={() =>
        state?.id
          ? useEditCompanyDistance(id!, state.id)
          : useCreateCompanyDistance(id!)
      }
      inputs={[
        getSelect({
          name: 'operator',
          data: [
            {label: 'Até', value: 'lte'},
            {label: 'Maior que', value: 'gt'},
          ],
        }),
        getNumberInput({name: 'distance'}),
        getPriceInput({name: 'deliveryPrice'}),
        getPriceInput({name: 'deliveryManFee'}),
      ]}
      border
    />
  );
};

export default CreateCompanyDistance;
